<template>
    <div>
        <h2 class="titulo">{{ title }}</h2>
        <div class="calendario">
            <table>
                <tr>
                    <th>D</th>
                    <th>S</th>
                    <th>T</th>
                    <th>Q</th>
                    <th>Q</th>
                    <th>S</th>
                    <th>S</th>
                </tr>
                <tr>
                    <td>30</td>
                    <td>1</td>
                    <td>2</td>
                    <td>3</td>
                    <td>4</td>
                    <td>5</td>
                    <td>6</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>8</td>
                    <td>9</td>
                    <td>10</td>
                    <td class="evento">11</td>
                    <td>12</td>
                    <td>13</td>
                </tr>
                <tr>
                    <td>14</td>
                    <td>15</td>
                    <td>16</td>
                    <td>17</td>
                    <td>18</td>
                    <td>19</td>
                    <td>20</td>
                </tr>
                <tr>
                    <td>21</td>
                    <td>22</td>
                    <td>23</td>
                    <td>24</td>
                    <td>25</td>
                    <td>26</td>
                    <td>27</td>
                </tr>
                <tr>
                    <td>28</td>
                    <td class="evento">29</td>
                    <td>30</td>
                    <td>31</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <ul>
                <li>11/05/207<strong>Marcha para Jesus</strong></li>
                <li>29/05/207<strong>Encontro de Jovens</strong></li>
            </ul>
        </div>
    </div>
</template>
<script type="text/javascript">
    export default {
        data() {
            return {
                title: 'Calendário',
                item: {}
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/home/Calendar.vue